import React, { useState } from 'react';
import './App.css';
import IrfanHaroonImg from './assets/images/Irfan Haroon.jpeg';
import HaleemaImg from './assets/images/haleema.jpeg';
import AliImg from './assets/images/ali.jpeg';
import HashimImg from './assets/images/hashim.jpeg';

const leader = {
  name: 'Muhammad Irfan Haroon',
  title: 'Advocate Supreme Court',
  image: IrfanHaroonImg,
  accent: 'Founder',
  focusAreas: ['Supreme Court', 'High Courts', 'District Courts'],
  bio:
    'Founder and lead counsel with nationwide appearances across the Supreme Court, High Courts, and District Courts. Known for meticulous preparation and hands-on client advocacy.',
};

const team = [
  {
    name: 'Hashim Irfan',
    title: 'Corporate, Civil and Family Lawyer',
    image: HashimImg,
    education: 'Law degree, Sindh Muslim Law College | Bachelors in Commerce, University of Karachi',
    practiceAreas: [
      'Corporate Advisory',
      'Civil Litigation',
      'Family Litigation',
      'Child Custody',
      'Divorce and Maintenance',
      'Post-Divorce Litigation',
      'Adoptions',
    ],
    bio:
      'Hashim Irfan is a lawyer dealing with Corporate, Civil and Family Litigation at Irfan Haroon & Associates. He has worked for four years with Habib Bank Limited and for a year with Pak Suzuki Motors Limited in the field of Corporate Advisory and Civil law. His expertise also includes Family Law and Child Custody, with the following areas in focus: divorce, child custody and maintenance, post-divorce litigation, and adoptions. In addition to a law degree from Sindh Muslim Law College, Hashim has also completed his Bachelors in Commerce from the University of Karachi. He uses his diverse work experience and broad study background to work in a practical and solution-oriented way.',
  },
  {
    name: 'Haleema Saeed',
    title: 'Advocate',
    image: HaleemaImg,
    contact: '03313530022',
    education: 'University of London | LLB (Hons.)',
    practiceAreas: ['Criminal Law', 'Civil Litigation', 'Family Law', "Women's Rights & Protection Cases"],
    bio:
      "Haleema Saeed is an Advocate with over three years of professional legal practice, primarily specializing in criminal law, with substantial experience in civil and family matters. She gained early professional exposure through an internship at the State Bank of Pakistan, Karachi, in the Legal Services Department, and in the National Assembly of Pakistan where she developed a strong foundation in regulatory and institutional law. Working at Irfan Haroon & Associates from the past three years, where she is involved in a wide range of complex legal matters. Her practice includes representing and assisting clients in sensitive and high-stakes cases involving domestic violence, sexual assault, early child marriage, and the protection of women's rights. Haleema is committed to ethical advocacy, strategic legal representation, and safeguarding the constitutional and legal rights of her clients before the trial court.",
  },
  {
    name: 'Ali Akbar Poonawala',
    title: 'Advocate High Court',
    image: AliImg,
    education: 'LL.B. (Hons.), Sindh Muslim Law College, Karachi — First Position',
    practiceAreas: [
      'Anti-Terrorism Cases',
      'Fraud & Misrepresentation Matters',
      'FIA Cases',
      'Civil & Corporate Litigation',
      'Rent & Domestic Matters',
      'Constitutional Petitions (High Court)'
    ],
    bio:
      "Mr. Poonawala is a distinguished legal professional with a strong academic and judicial background. He completed his LL.B. (Hons.) from Sindh Muslim Law College, Karachi, securing First Position in his batch. He has undertaken Mediation Training by K.C.D.R, Gender Sensitization Training by Sindh Judicial Academy in collaboration with Aurat Foundation, Judicial Service Training by Sindh Judicial Academy, and a Workshop on Refugee Law organized by SHARP. Mr. Poonawala began his career with M/s. Rasheed A. Rizvi & Associates and was later inducted into judicial service as a Civil Judge-cum-Judicial Magistrate in 2013. His combined experience as an Advocate and Judicial Officer equips him to handle complex Anti-Terrorism matters, fraud and misrepresentation cases, FIA-related matters, and a wide range of civil, corporate, rent, domestic, and constitutional petitions before the High Court of Sindh. He is known for his integrity, principled approach, and dedicated representation before the Hon’ble High Court of Sindh, Special Courts, Quasi-Judicial Forums, and Subordinate Courts. He also handles criminal cases, including but not limited to financial fraud matters.",
  },
];

const teamStrengths = [
  {
    title: 'Senior-led strategy',
    copy: 'Core litigation and advisory work is supervised directly by experienced counsel from briefing through execution.',
  },
  {
    title: 'Prepared for hearings',
    copy: 'The team supports drafting, research, evidence review, and procedural follow-through across active matters.',
  },
  {
    title: 'Client-facing coordination',
    copy: 'Members work closely with individuals, families, corporates, and overseas clients who need structured updates.',
  },
];

function getProfileSummary(member) {
  if (member.education) {
    return member.education;
  }

  return member.bio;
}

function OurTeam() {
  const [activeProfile, setActiveProfile] = useState(null);

  const renderProfileCard = (member) => (
    <button
      key={member.name}
      type="button"
      className="team-member-card"
      onClick={() => setActiveProfile(member)}
    >
      {member.image ? <img src={member.image} alt={member.name} /> : null}
      <div className="team-member-body">
        <p className="team-member-role">{member.title}</p>
        <h3>{member.name}</h3>
        <p className="team-member-summary">{getProfileSummary(member)}</p>
        {member.practiceAreas ? (
          <div className="team-member-tags">
            {member.practiceAreas.slice(0, 3).map((area) => (
              <span key={area} className="team-member-tag">
                {area}
              </span>
            ))}
          </div>
        ) : null}
        <span className="team-member-link">View profile</span>
      </div>
    </button>
  );

  return (
    <main className="team">
      <section className="section-head">
        <p className="eyebrow">Our Team</p>
        <h2>Advocates committed to strategy, precision, and trusted counsel.</h2>
        <p>
          A dedicated team supporting litigation, advisory work, and client advocacy across Pakistan and abroad.
        </p>
      </section>

      <section className="team-overview">
        {teamStrengths.map(({ title, copy }) => (
          <article key={title}>
            <h3>{title}</h3>
            <p>{copy}</p>
          </article>
        ))}
      </section>

      <section className="team-leader">
        <div className="team-leader-layout">
          <div className="team-leader-media">
            <img src={leader.image} alt={leader.name} />
          </div>
          <div className="team-leader-content">
            <p className="eyebrow">{leader.accent}</p>
            <h3>{leader.name}</h3>
            <p className="team-leader-title">{leader.title}</p>
            <p>{leader.bio}</p>
            <div className="team-leader-tags">
              {leader.focusAreas.map((item) => (
                <span key={item} className="team-member-tag">
                  {item}
                </span>
              ))}
            </div>
            <button type="button" className="button button-small" onClick={() => setActiveProfile(leader)}>
              View full profile
            </button>
          </div>
        </div>
      </section>

      <section className="team-directory">
        <div className="team-directory-head">
          <p className="eyebrow">Advocates</p>
          <h2>Experienced practitioners supporting litigation, advisory work, and courtroom execution.</h2>
          <p>
            The firm&apos;s advocates contribute hands-on drafting, hearings support, and client coordination across
            sensitive and high-stakes matters.
          </p>
        </div>
        <div className="team-directory-grid">
          {team.map(renderProfileCard)}
        </div>
      </section>

      {activeProfile ? (
        <div className="modal-backdrop" role="dialog" aria-modal="true">
          <div className="modal">
            <div className="modal-header">
              <div>
                <h3>{activeProfile.name}</h3>
                <p className="card-accent">{activeProfile.title}</p>
              </div>
              <button type="button" className="modal-close" onClick={() => setActiveProfile(null)}>
                Close
              </button>
            </div>
            {activeProfile.image ? (
              <img src={activeProfile.image} alt={activeProfile.name} className="modal-image" />
            ) : null}
            {activeProfile.contact ? (
              <p>
                <strong>Contact:</strong> <a href={`tel:${activeProfile.contact}`}>{activeProfile.contact}</a>
              </p>
            ) : null}
            {activeProfile.education ? (
              <p>
                <strong>Education:</strong> {activeProfile.education}
              </p>
            ) : null}
            {activeProfile.practiceAreas ? (
              <div>
                <p>
                  <strong>Practice Areas:</strong>
                </p>
                <ul>
                  {activeProfile.practiceAreas.map((area) => (
                    <li key={area}>{area}</li>
                  ))}
                </ul>
              </div>
            ) : null}
            {activeProfile.bio ? <p>{activeProfile.bio}</p> : null}
          </div>
          <button
            type="button"
            className="modal-overlay"
            aria-label="Close"
            onClick={() => setActiveProfile(null)}
          />
        </div>
      ) : null}
    </main>
  );
}

export default OurTeam;
